import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

import { environment } from "environments/environment";
import { BaseService } from "./base.service";

@Injectable()
export class BlastEmailTemplateService extends BaseService {
  constructor (
    protected http: HttpClient
  ) {
    super(http, `${environment.apiBaseUrl}/blast_email_templates`);
  }

  send(id: string, recipients: any): Observable<any> {
    const url = this.baseUrl + `/${id}/send`;
    console.log(url)
    return this.http.post<any>(url, recipients);
  }
}